import { LOCALE_CHANGED } from './constants'
import getLocales from './api'

const initialState = { locale: 'en', locales: getLocales() }

// sample state:
// const initialState = {
//     locale: 'en',
//     locales: {
//         en: {
//             tooltipText: '',
//         },
//     },
// }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Locale changed
        case LOCALE_CHANGED: {
            return { ...state, locale: action.payload }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Clock/data/clock/reducers.js